import dashboardArchitectureImage from '../../../assets/common/architecture_summary.png';
import dashboardBetaTestImage from '../../../assets/common/beta-test.svg';
import BGPattern from '../../../assets/common/bg-pattern.svg';
import dashboardGoLiveImage from '../../../assets/common/go-live.svg';
import dashboardIntro1 from '../../../assets/common/introduction-intro-1.svg';
import dashboardIntro2 from '../../../assets/common/introduction-intro-2.svg';
import dashboardPreRequisitesImage from '../../../assets/common/prerequisites.svg';
import dashboardProductionReadinessImage from '../../../assets/common/production-readiness.svg';
import activateProduct from '../../../assets/gd/activate-product.svg';
import dashboardEntitlementsHeader from '../../../assets/gd/dashboard-entitlements-header.svg';
import dontUseEntitlementServer from '../../../assets/gd/dont-use-entitlement-server.svg';
import entitlementsGetStarted from '../../../assets/gd/entitlements-get-started.svg';
import entitlementsGetStarted2 from '../../../assets/gd/entitlements-get-started-2.svg';
import backgroundLoginImage from '../../../assets/gd/login-background.svg';
import logo from '../../../assets/gd/logo.svg';
import logoLight from '../../../assets/gd/logo-light.svg';
import logoMini from '../../../assets/gd/logo-mini.svg';
import useEntitlementServer from '../../../assets/gd/use-entitlement-server.svg';
import { Config } from './types/brands';

export const gdConfig: Config = {
  context: 'gd',
  assets: {
    activateProduct,
    backgroundLoginImage,
    dashboardEntitlementsHeader,
    dontUseEntitlementServer,
    entitlementsGetStarted,
    entitlementsGetStarted2,
    useEntitlementServer,
    logoMini,
    logo,
    logoLight,
    onboarding: {
      dashboardIntro1,
      dashboardIntro2,
      architecture: dashboardArchitectureImage,
      prerequisites: dashboardPreRequisitesImage,
      productionReadiness: dashboardProductionReadinessImage,
      betaTest: dashboardBetaTestImage,
      goLive: dashboardGoLiveImage,
    },
    reviewBgPattern: BGPattern,
  },
  i18n: {
    variables: {
      companyName: 'G+D',
      productName: 'AirOn360® ES',
      productFullName: 'G+D AirOn360® ES',
      portalFullName: 'G+D AirOn360® ES Portal',
      saasFullName: 'G+D AirOn360® ES Portal',
      supportEmail: 'support@airon360es.com',
      productionSupportEmail: 'productionsupport@airon360es.com',
      productionSupportTickets: 'https://gdmsps-portal.gi-de.com/ePortal',
      uesContractUrl: '',
    },
  },
  environments: {
    settings: {
      companyFlag: 'GD',
      sideMenuLogoHeight: '48px',
      sideMenuLogoPadding: '4px 0',
      termOfServiceUrl:
        'https://www.gi-de.com/corporate/files/AirOn360-ES-TCs.pdf',
      privacyPolicyURL: 'https://www.airon360es.com/privacy-policy',
      cookiesPolicyURL: '/cookie-policy',
      imprintUrl: 'https://www.gi-de.com/en/imprint',
      poweredBy: 'Powered by NetLync',
    },
  },
};
